import { LitElement, html } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-vehicle-and-loan-mfe';
import { style } from './iconic-license-plate-inputs.style.js';
import { DebugService } from '../../../shared/services/debug.service.js';
import { forms } from '../../../shared/styles/forms.style.js';
import { REFI_VEHICLE_LOAN_CONST } from '../../../shared/constants/app.constants.js';
import { VehicleService } from '../../../services/vehicle.service.js';
import { stratum } from '../../../../constants/stratum.js';
import { SessionService } from '../../../core/services/session/session.service.js';
import { ApplicationService } from '../../../services/application.service.js';

class RefiIconicLicensePlateInputs extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiIconicLicensePlateInputs');
    this.vehicleLookupModel = {};
  }

  connectedCallback() {
    super.connectedCallback();
    this.vehicleLookupModel = VehicleService.vehicleLookupModel;
  }

  firstUpdated() {
    if (!ApplicationService.isInAppDeclineDelayOn) {
      stratum.publishTag(TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN);
      stratum.publishTag(
        TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOOKUP
      );
    }
  }

  static properties = {
    vehicleLookupModel: { type: Object, reflect: true },
  };

  static styles = [style, forms];

  stateOptions() {
    const mapper = (state) =>
      html`<option value="${state.value}">${state.name}</option>`;
    return html`<option value="">Select State</option>
      ${REFI_VEHICLE_LOAN_CONST.US_STATES.map(mapper)}`;
  }

  changed(name, ev) {
    if (name === 'licensePlateStateCode') {
      // If licensePlateStateCode is changed, save it in session cache
      SessionService.setLicensePlateStateCode(ev.target.value);
    }
    this.vehicleLookupModel[name] = ev?.target?.value.trim();

    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: {
          name,
          isValid: ev?.target?.checkValidity(),
        },
      })
    );
  }

  render() {
    this.debug.log('rendered');
    // aria-only?
    return html`
      <div class="grid">
        <fs-text-field
          class="includes-error-message"
          id="licensePlateNumber"
          name="licensePlateNumber"
          type="text"
          value-missing-message="Please enter a valid license plate"
          maxLength="10"
          required
          @change="${(e) => {
            e.target.value = e.target.value.toUpperCase();
            this.changed('licensePlateNumber', e);
          }}"
          value="${this.vehicleLookupModel.licensePlateNumber}"
          data-e2e-ref="fldLicensePlate"
          >License Plate Number</fs-text-field
        >
        <fs-select
          id="licensePlateStateCode"
          name="licensePlateStateCode"
          required
          value="${this.vehicleLookupModel.licensePlateStateCode}"
          value-missing-message="Please select a state from the dropdown menu"
          @blur="${(e) => this.changed('licensePlateStateCode', e)}"
          @change="${(e) => this.changed('licensePlateStateCode', e)}"
          data-e2e-ref="fldVehicleState"
        >
          <span slot="label">State</span>
          ${this.stateOptions()}
        </fs-select>
      </div>
    `;
  }
}

customElements.define(
  'refi-iconic-license-plate-inputs',
  RefiIconicLicensePlateInputs
);
